<!-- HTML -->
<template>
  <div>

    <!-- Level 1 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column left-column is-5 z-bot">
            <div class="scene-3d">
              <div class="level-3d left-side rotate-clockwise" ref="level-1-left">
                <figure class="image">
                  <img src="../../assets/img/home/industrial-bridge.jpg" alt="A photograph of Jugem's Cloud on an industrial bridge">
                </figure>
                <h5>
                  Photograph by Dave Ludwin
                </h5>
              </div>
            </div>
          </div>
          <div class="column right-column is-5 z-top">
            <div class="scene-3d">
              <div class="level-3d right-side rotate-counter-clockwise" ref="level-1-right">
                <div class="text-box-container">
                  <div class="text-box-wrapper">
                    <h1 class="title is-1">
                      Chicago
                      <br>
                      Industrial
                      <br>
                      Music
                    </h1>
                    <h3 class="subtitle is-3">
                      //////
                    </h3>
                    <p>
                      Jugem's Cloud is an aggressive electro industrial band, blending modern sounds with a fresh take on classic industrial music. Emerging from the bowels of Chicago's factories and steel refineries, Jugem's Cloud writes with solid songwriting, heavy synth basslines, crushing drums, and pounding samples for an unforgettable and fully industrial combination.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Level 2 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column left-column is-5 is-offset-2 z-top">
            <div class="scene-3d">
              <div class="level-3d left-side rotate-clockwise" ref="level-2-left">
                <div class="text-box-container">
                  <div class="text-box-wrapper">
                    <h1 class="title is-1">
                      The
                      <br>
                      Factory
                      <br>
                      Bloc
                    </h1>
                    <h3 class="subtitle is-3">
                      //////
                    </h3>
                    <p>
                      The sophomore masterpiece by Jugem's Cloud is finally here! Jam-packed with 12 tracks of full-on assault-level industrial.
                    </p>
                    <p>
                      A concept album several years in the making, it explorers the heavy industrialization of the planet, and human's forced involvement in it's relentlessness. The experiences and consequences of the living in <i>The Factory Bloc</i> shape who we are today, and we tried to capture that human experience.
                    </p>
                    <p>
                      RELEASE DATE = [ NOVEMBER 19TH, 2020 ]
                    </p>
                    <p>
                      REVIEWS:
                      <br>
                      <a href="https://www.theinfidelnetwerk.com/post/fresh-trax-jugem-s-cloud-tentacle" target="_blank">Tentacle | The Infidel Netwerk</a>
                      <br>
                      <a href="https://www.theinfidelnetwerk.com/post/fresh-trax-jugem-s-cloud-belt-driven-tragedy-1" target="_blank">The Factory Bloc | The Infidel Netwerk</a>
                      <br>
                      <a href="https://www.theinfidelnetwerk.com/post/fresh-trax-jugem-s-cloud-belt-driven-tragedy" target="_blank">Belt Driven Tragedy | The Infidel Netwerk</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column right-column is-5 z-bot">
            <div class="scene-3d">
              <div class="level-3d right-side rotate-counter-clockwise" ref="level-2-right">
                <figure class="image">
                  <img src="../../assets/img/band/the-factory-bloc-cover.jpg" alt="Cover artwork for Jugem's Cloud album The Factory Bloc">
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Level 3 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column left-column is-5 z-bot">
            <div class="scene-3d">
              <div class="level-3d left-side rotate-clockwise" ref="level-3-left">
                <figure class="image">
                  <img src="../../assets/img/band/skeleton-structure.jpg" alt="An abandoned skeleton of a blast furnace">
                </figure>
              </div>
            </div>
          </div>
          <div class="column right-column is-5 z-top">
            <div class="scene-3d">
              <div class="level-3d right-side rotate-counter-clockwise" ref="level-3-right">
                <div class="text-box-container">
                  <div class="text-box-wrapper">
                    <h1 class="title is-1">
                      The
                      <br>
                      Beginning...
                    </h1>
                    <h3 class="subtitle is-3">
                      //////
                    </h3>
                    <p>
                      The early beginnings of Jugem's Cloud go back to the formative years of Mark Lewandowski. Experiencing Industrial music for the first time on Zoltar's The Industrial Zone on Q101, he was inspired by the electrical sounds and dark mysterious nature of the genre. His older brother Michael Lewandowski would then bring industrial CD's on a boombox, and they would listen on their scouting camping trips. The combination of a forest atmosphere, combined with aggressive and haunting industrial music inspired Mark Lewandowski to start writing his own electronic compositions. He acquired a Korg Electribe EA-1 and started experimenting with sounds.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Level 4 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column left-column is-5 is-offset-2 z-top">
            <div class="scene-3d">
              <div class="level-3d left-side rotate-clockwise" ref="level-4-left">
                <div class="text-box-container">
                  <div class="text-box-wrapper">
                    <h1 class="title is-1">
                      Nature
                      <br>
                      Vs
                      <br>
                      Humans
                    </h1>
                    <h3 class="subtitle is-3">
                      //////
                    </h3>
                    <p>
                      The debut album by Jugem's Cloud. Dark, intriguing, and intoxicating, the 14 tracks of 80s and 90s inspired industrial will draw you in.
                    </p>
                    <p>
                      This album is a rabbit hole, masterfully balancing industrial heavy-hitters with exploratory instrumentals and peppered ambience. It includes the singles The Craftenstock Corporation, Snow Zone, and Hydrocompression. Experience it now.
                    </p>
                    <p>
                      RELEASE DATE = [ OCTOBER 28TH, 2014 ]
                    </p>
                    <p>
                      REVIEWS:
                      <br>
                      <a href="https://www.theinfidelnetwerk.com/post/2017/02/12/jugems-cloud-infidel-interview-69" target="_blank">The Infidel Netwerk</a>
                      <br>
                      <a href="https://blackaudio.wordpress.com/2014/12/15/jugems-cloud-nature-vs-humans-cd-self-released/" target="_blank">blackaudio</a>
                      <br>
                      <a href="https://www.strawberrytongue.com/friday-night-five-20160923/" target="_blank">Strawberry Tongue Radio</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column right-column is-5 z-bot">
            <div class="scene-3d">
              <div class="level-3d right-side rotate-counter-clockwise" ref="level-4-right">
                <figure class="image">
                  <img src="../../assets/img/band/nature-vs-humans-cover.jpg" alt="Cover artwork for Jugem's Cloud album Nature Vs Humans">
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Level 5 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column left-column is-8 is-offset-2 z-bot">
            <div class="scene-3d">
              <div class="level-3d left-side rotate-clockwise" ref="level-5-left">
                <figure class="image">
                  <img src="../../assets/img/band/mark-lewandowski.jpg" alt="A photograph of Mark Lewandowski from Jugem's Cloud">
                </figure>
              </div>
            </div>
          </div>
        </div>
        <div class="columns stage-3d">
          <div class="column right-column is-10 is-offset-1 z-top">
            <div class="scene-3d">
              <div class="level-3d right-side rotate-counter-clockwise" ref="level-5-right">
                <div class="text-box-container">
                  <div class="text-box-wrapper">
                    <h1 class="title is-1">
                      Mark
                      <br>
                      Lewandowski
                    </h1>
                    <h3 class="subtitle is-3">//////</h3>
                    <h5 class="subtitle is-5">Vocals | Guitar | Programming</h5>
                    <h5><i class="fab fa-twitter"></i> <a href="https://twitter.com/JugemsCloud" target="_blank"><i class="fas fa-at"></i>JugemsCloud</a></h5>
                    <p>Mark Lewandowski is the mastermind and brainchild behind Jugem's Cloud. He is the primary songwriter, lead vocalist, programmer and guitarist of the band.</p>
                    <p>Before ever creating Jugem's Cloud, Mark found inspiration in the dark forests, frozen landscapes, and abandoned structures of the past. His youthful exploration into the unknown and fascination with industrial music formed an early vision for his own sound. The combination of an elusive music format with overgrown landscapes created a musical vision inside of Mark, one which would plant it's seeds and grow into what is known today as Jugem's Cloud.</p>
                    <p>Within a couple years Mark picked-up a small Korg Electribe EA-1, and then an ER-1. He would tirelessly program on the units and create solid, yet primordial music. Although inexperienced and young, Mark formed Jugem's Cloud as a solo side-project in 1999. Cutting his teeth on basic synthesizer programming and experimentation, he soon began to formulate his visionary sound of what he felt industrial music should be.</p>
                    <p>Years passed and Mark experimented with more advanced synthesizers, MIDI setups, and music production techniques. He spent much of his time at Northern Illinois University playing guitar, bass, and teaching himself music theory. After graduation from college in 2007, Mark began to purchase and acquire the necessary instruments and equipment to truly make Jugem's Cloud happen.</p>
                    <p>The true beginnings of the writing of Nature Vs Humans began in mid 2010. At this point, Mark had purchased the core pieces of machinery to truly begin writing and programming his first album. For the next three years, Mark worked tirelessly to program his musical vision. Working and experimenting with synthesizers and drum machines on a nearly daily basis, he slowly put together the sound and style of Jugem's Cloud. He recruited his brother Michael and long-time friend Rob to assist with the album, and they both officially joined in 2012. The band was then complete.</p>
                    <p>Mark continues to be the primary force behind Jugem's Cloud. He writes, produces, programs, mixes and creates the music of the band, and is also responsible for the website design, art direction and imagery related to the band.</p>
                    <p>Aliases: Dowski | Lord Liquorish</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Level 6 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column right-column is-8 is-offset-2 z-bot">
            <div class="scene-3d">
              <div class="level-3d right-side rotate-counter-clockwise" ref="level-6-right">
                <figure class="image">
                  <img src="../../assets/img/band/rob-ludwin.jpg" alt="A photograph of Rob Ludwin from Jugem's Cloud">
                </figure>
                <h5>Photograph by Dave Ludwin</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="columns stage-3d">
          <div class="column left-column is-10 is-offset-1 z-top">
            <div class="scene-3d">
              <div class="level-3d left-side rotate-clockwise" ref="level-6-left">
                <div class="text-box-container">
                  <div class="text-box-wrapper">
                    <h1 class="title is-1">
                      Rob
                      <br>
                      Ludwin
                    </h1>
                    <h3 class="subtitle is-3">//////</h3>
                    <h5 class="subtitle is-5">Vocals | Synthesizer | Programming</h5>
                    <p>Rob grew up in the Northwest Chicago suburbs on rock, metal, and industrial music. Since he was a life long friend of the Lewandowski brothers, he shared musical recommendations and influences. When Mark moved in with Rob in the Chicago suburbs, it was only a matter of time before work started on Mark's concept industrial band he'd envisioned since his teens.</p>
                    <p>Rob brings a fresh pair of ears, as well as a metal influence to Jugem's Clouds' sound. He decided to try adding to the vocals, and it fortunately added another level of aggressiveness. Rob also works with programming and writing Jugem's Cloud's songs.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Level 7 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column left-column is-8 is-offset-2 z-bot">
            <div class="scene-3d">
              <div class="level-3d left-side rotate-clockwise" ref="level-7-left">
                <figure class="image">
                  <img src="../../assets/img/band/michael-lewandowski.jpg" alt="A photograph of Michael Lewandowski from Jugem's Cloud">
                </figure>
                <h5>Photograph by Dave Ludwin</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="columns stage-3d">
          <div class="column right-column is-10 is-offset-1 z-top">
            <div class="scene-3d">
              <div class="level-3d right-side rotate-counter-clockwise" ref="level-7-right">
                <div class="text-box-container">
                  <div class="text-box-wrapper">
                    <h1 class="title is-1">
                      Michael
                      <br>
                      Lewandowski
                    </h1>
                    <h3 class="subtitle is-3">//////</h3>
                    <h5 class="subtitle is-5">Sampling | Programming</h5>
                    <p>Michael Lewandowski (1983-) is the main sampler, drum and percussion artist behind Jugem's Cloud. He creates, manipulates, records, and plays samples, and additionally specializes in drums and percussion. A long supporter of Jugem's Cloud, Mike saw and appreciated his brothers' love for creating industrial music, and joined.</p>
                    <p>Sometime around 1995 and/or 1996, Mike created home-made Q101 Industrial Zone mix-tapes that they would listen to on a cheap, battery powered boombox. The music was inspirational, and Mike and Mark would create crude percussion sounds with found objects such as metal pipes, cabinets, and resonant objects.</p>
                    <p>Michael has amassed a quality massive industrial music collection, including CDs, tapes, records, various metal instruments, beaters, and more. He is also classically trained on the trap set, percussion, music and sound. Mike has always played music; there have been many groups. The last time he played a drum kit with a band was with the Familiar Names of Portland OR at a reunion concert in 2014. He is currently working on new sound samples for The Factory Bloc, recording movie samples, and categorizing 33's for future samples.</p>
                    <p>Michael's main role in Jugem's Cloud is to run the sequencer (NI Maschine), and play live samples.</p>
                    <p>Alias: Petyr Plumm</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Level 8 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column right-column is-10 is-offset-1 z-bot">
            <div class="scene-3d">
              <div class="level-3d right-side rotate-counter-clockwise" ref="level-8-right">
                <figure class="image">
                  <img src="../../assets/img/band/jugems-cloud-glitch.jpg" alt="Jugem's Cloud Glitch">
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Level 9 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column left-column is-10 is-offset-1 z-bot">
            <div class="scene-3d">
              <div class="level-3d left-side rotate-clockwise" ref="level-9-right">
                <figure class="image">
                  <img src="../../assets/img/band/jugems-cloud-electrocution.jpg" alt="Jugem's Cloud Electrocution">
                </figure>
                <h5>Photograph by Dave Ludwin</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Level 8 -->
    <section class="section">
      <div class="container">
        <div class="columns stage-3d">
          <div class="column right-column is-10 is-offset-1 z-bot">
            <div class="scene-3d">
              <div class="level-3d right-side rotate-counter-clockwise" ref="level-10-right">
                <figure class="image">
                  <img src="../../assets/img/band/jugems-cloud-junkyard.jpg" alt="Jugem's Cloud Junkyard">
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<!-- JavaScript -->
<script>

export default {

  name: "BandDescend",

  methods: {

    // Create Observer Function Constructor
    createObserver( myRoot, myRootMargin, myThreshold, myTarget ) { // Pass in options when called
     let observer;
     let options = {
       root: myRoot,
       rootMargin: myRootMargin,
       threshold: myThreshold
     };

     // Create a new IntersectionObserver with the constructor
     observer = new IntersectionObserver(this.handleIntersect, options);

     // Target HTML elements that we will be watching are .level-#
     observer.observe(myTarget);

    },

    // Create Threshold List Function
    buildThresholdList( myNumSteps) {
      let thresholds = [];
      let numSteps = myNumSteps; // Number of steps
      for (let i=1.0; i<=numSteps; i++) {
        let ratio = i/numSteps;
        thresholds.push(ratio);
      }
      thresholds.push(0);
      return thresholds;
    },

    // Function that is run whenever the element is observed per the threshold
    // The callback function is automatically passed the intersectionObserverEntry object, which can be referenced with "entries"
    handleIntersect(entries) {

      if ( entries[0].target.classList.contains('left-side') === true ) {

        if ( entries[0].intersectionRatio >= .5 ) {
          entries[0].target.classList.remove('rotate-clockwise');
          entries[0].target.classList.add('rotate-counter-clockwise');
        }
        if ( entries[0].intersectionRatio < .5 ) {
          entries[0].target.classList.remove('rotate-counter-clockwise');
          entries[0].target.classList.add('rotate-clockwise');
        }

      } else {

        if ( entries[0].intersectionRatio >= .5 ) {
          entries[0].target.classList.remove('rotate-counter-clockwise');
          entries[0].target.classList.add('rotate-clockwise');
        }
        if ( entries[0].intersectionRatio < .5 ) {
          entries[0].target.classList.remove('rotate-clockwise');
          entries[0].target.classList.add('rotate-counter-clockwise');
        }

      }

    },

    // Create all the Intersection Observers
    createIntersectionObservers() {

      // Loop through list of $refs
      for (var property in this.$refs) {
        this.createObserver( null, '0px', this.buildThresholdList(10), this.$refs[property] );
      }

    }

  },

  mounted() {

    this.createIntersectionObservers();

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

h1 {
  font-family: astera;
  color: $white;
}
h3 {
  color: $green-tint-2;
}
h5 {
  font-family: astera;
  color: $white-trans-1;
}
a {
  text-decoration: underline;
  color: $white-trans-1;
}
a:hover {
  color: $white-trans-2;
}
p {
  padding-bottom: 1rem;
  font-family: astera;
}

.section {
  padding: 10rem 0;
  background-color: $black;
}
.left-column {
  transform:translateX(1rem);
}
.right-column {
  transform:translateX(-1rem);
}
.text-box-container {
  position: relative;
  height: 100%;
  width: 100%;
}
.text-box-wrapper {
  padding-top: 2rem;
  padding-left: 2rem;
  border-top: 2px solid $green-tint-2;
  border-left: 2px solid $green-tint-2;
  background-image: -webkit-linear-gradient(135deg, $black, rgba(0,0,0,0.1)); /* Safari 5.1, iOS 5.0-6.1, Chrome 10-25, Android 4.0-4.3 */
  background-image: -moz-linear-gradient(135deg, $black, rgba(0,0,0,0.1)); /* Firefox 3.6 - 15 */
  background-image: -o-linear-gradient(135deg, $black, rgba(0,0,0,0.1)); /* Opera 11.1 - 12 */
  background-image: linear-gradient(to right, $black, rgba(0,0,0,0.1)); /* Opera 15+, Chrome 25+, IE 10+, Firefox 16+, Safari 6.1+, iOS 7+, Android 4.4+ */
  background-image: linear-gradient(135deg, $black, rgba(0,0,0,0.1));
}

/* 3D */
.scene-3d {
  perspective: 60em; // Amount of depth
}
.level-3d {
  transition: transform 1.5s;
  transform-style: preserve-3d;
}
.rotate-clockwise {
  transform: rotateY(-18deg);
}
.rotate-counter-clockwise {
  transform: rotateY(18deg);
}
.z-bot {
  z-index: 1;
}
.z-top {
  z-index: 2;
}

</style>
